import { Label, TextInput } from 'flowbite-react'
import { FormikValues } from 'formik'

interface CustomSelectProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  formik: FormikValues
  label?: string
  field: string
  placeholder?: string
  addon?: string
  mask?: (value: string) => string
  maxDigits?: number
}

const CustomTextInput = ({
  formik,
  field,
  placeholder,
  addon,
  label,
  type,
  mask,
  maxDigits,
  ...props
}: CustomSelectProps) => {

  return (
    <>
      {label && <Label htmlFor={field}>{label}</Label>}
      <TextInput
        id={field}
        type={type}
        addon={addon}
        placeholder={placeholder}
        maxLength={maxDigits}
        color={formik.touched[field] && formik.errors[field] ? 'failure' : ''}
        helperText={formik.touched[field] && formik.errors[field]}
        {...formik.getFieldProps(field)}
        {...props}
        value={mask ? mask(formik?.values[field]) : formik?.values[field]}
      />
    </>
  )
}

export default CustomTextInput
